import { createDefaultTyrann, axiosRequestConfig } from '@apis/common';
import { delegation } from '@models/Delegation';
import { getConfig } from '@utils/config';
import { FormError } from '@utils/errors';
import Axios from 'axios';

export const delegationApis = createDefaultTyrann({
  '/delegation/': {
    get: {
      response: {
        200: delegation,
      },
    },
  },
});

export const uploadDelegationForm = async ({
  file,
  onProgress,
}: {
  file: File;
  onProgress?: (progress: number) => void;
}) => {
  const form = new FormData();
  form.append('file', file, 'Form.pdf');

  const response = await Axios.post(`${getConfig().serverUrl}/delegation/`, form, {
    ...axiosRequestConfig(),
    onUploadProgress: (e) => {
      onProgress?.(e.total ? e.loaded / e.total : 0);
    },
  });

  if (response.status === 403) {
    throw new FormError('uploadChecklist', { message: response.data.message });
  }
};
